/**
 * (c) 2021-2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import { contentLanguages } from "../reference/content";
import { Idea } from "./model";
import { baseUrl } from "../../base";

/**
 * Laedt die Ideen aus lokal gebuendelten Inhalten.
 *
 * Wie schon beim Referenz-Tab: die Inhalte des CMS der Micro:bit Foundation
 * sind nicht Open Source und in einem fremden Deployment ohnehin durch CORS
 * gesperrt. Sind noch keine eigenen Ideen hinterlegt, bleibt der Bereich leer,
 * statt eine Fehlermeldung zu zeigen.
 */
export const fetchIdeas = async (languageId: string): Promise<Idea[]> => {
  for (const candidate of contentLanguages(languageId)) {
    const ideas = await fetchLocalIdeas(candidate);
    if (ideas) {
      return ideas;
    }
  }
  return [];
};

const fetchLocalIdeas = async (
  languageId: string
): Promise<Idea[] | undefined> => {
  const response = await fetch(
    `${baseUrl}content/ideas/${encodeURIComponent(languageId)}.json`
  );
  if (!response.ok) {
    return undefined;
  }
  return adaptContent(await response.json());
};

const adaptContent = (result: any): Idea[] | undefined => {
  return result?.pythonIdeasOrder ?? [];
};
